$('body').on('click', '.edit-site-text-trigger', function() {
    var data = $(this).parents('.site-text');
    $('.edit-site-text form').attr('action', $('.edit-site-text form').attr('data-action')+data.attr('data-site_text'));
    $('.edit-site-text textarea[name="text"]').val(data.attr('data-text'));
    openModal('.edit-site-text');
    return false;
});

$('body').on('submit', '.edit-site-text form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            // console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});



channel.bind('process-site-text', function(data) {
    var siteText;

    if($('.site-text[data-site_text="'+data.site_text+'"]').length) {
        siteText = $('.site-text[data-site_text="'+data.site_text+'"]');
        siteText.attr('data-text', data.text);
        siteText.find('[data-input="name_parsed"]').html(data.name_parsed);
        return;
    }
});